import { ImgHTMLAttributes } from 'react';
import manifest from '../data/imageManifest.json';

type ImageAsset = { src: string; srcSet: string; width: number; height: number };
const images: Record<string, ImageAsset> = manifest;

export const publicImagePath = (src: string) => '/' + src.replace(/^\.?\//, '');
export const imageAsset = (src: string) => images[publicImagePath(src)];

type Props = ImgHTMLAttributes<HTMLImageElement> & { src: string; alt: string; priority?: boolean };

export default function ResponsiveImage({ src, alt, priority = false, sizes = '100vw', ...props }: Props) {
  const asset = imageAsset(src);
  return <img
    src={asset?.src || publicImagePath(src)}
    srcSet={asset?.srcSet}
    width={asset?.width}
    height={asset?.height}
    sizes={asset ? sizes : undefined}
    alt={alt}
    loading={priority ? 'eager' : 'lazy'}
    decoding="async"
    {...(priority ? { fetchpriority: 'high' } : {})}
    {...props}
  />;
}
